/* eslint-disable sort-keys */
export default {
    Avatar: {
        parts: [
            "badge", "label", "container", "excessLabel"
        ],
        baseStyle: {},
        variants: {
            unstyled: {
                container: {
                    borderWidth: "0"
                }
            },
            default: {
                excessLabel: {
                    color: "white",
                    fontSize: "p4",
                    bgColor: "primary.700",
                    borderColor:"white",
                    borderWidth: "2",
                    borderStyle: "solid",
                    w: "8",
                    h: "8"
                },
                container: {
                    "_hover": {
                        zIndex: 1,
                    },
                    "bgColor": "primary.700",
                    "color": "white",
                    "> .chakra-avatar__initials": { color: "white", fontSize: "p4", lineHeight: "normal" } 
                }
            },
        },
        sizes: {},
        defaultProps: {
            variant: "default"
        }
    }
};
